import { useEffect, useRef } from "react";

import { useMarketCalculator } from "~/feature/event/providers/MarketCalculatorProvider";
import { useScreenResolution } from "~/hooks/useScreenResolution";

export const useCalculatorVisibility = () => {
  const { setIsCalculatorVisible } = useMarketCalculator();
  const calculatorRef = useRef<HTMLDivElement>(null);
  const marketsTableRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useScreenResolution();

  useEffect(() => {
    if (!isMobile) {
      const el = calculatorRef.current;
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => setIsCalculatorVisible(entry.intersectionRatio >= 0.01),
        { threshold: [0, 0.01, 1] }
      );

      observer.observe(el);
      return () => observer.disconnect();
    } else {
      const el = marketsTableRef.current;
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => setIsCalculatorVisible(!(entry.intersectionRatio >= 0.3)),
        { threshold: [0, 0.3, 1] }
      );

      observer.observe(el);
      return () => observer.disconnect();
    }
  }, [setIsCalculatorVisible, isMobile]);

  return { calculatorRef, marketsTableRef };
};
